import React, { useEffect } from 'react';
import './index.scss';
import SearchBar from '../SearchBar/index.jsx';
import { Helmet } from 'react-helmet';
import {
  BROWSE_PRESC_DESC_ES,
  BROWSE_PRESC_DESC_EN,
  HOME_CANONICAL
} from '../../constants/defaults';
import _ from 'lodash';
import BrowseTopDrugs from './BrowseTopDrugs/index.jsx';
import SavingsSectionv2 from '../static/SavingsSectionv2.jsx';
import { withTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { object } from 'prop-types';
import SkipTo from '../common/Tag/SkipTo';
import AppsPromoHome from '../AppsPromoHome';
import { HOTJAR_SCRIPT } from '../../constants/hotjarScript.js';
const { API } = require('../../config/' + process.env.REACT_APP_ENV);
const alphabets = [...Array(26).keys()].map(i => String.fromCharCode(i + 65));

const BrowsePrescriptionsMain = ({ respData, t, i18n, location, history }) => {
  let isEs = _.isEqual(i18n.language, 'es');

  const toggleSearch = () => {
    const clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    const myButton = document.getElementById('mobile-search-icon');
    myButton.dispatchEvent(clickEvent);
  };

  useEffect(() => {
    if (window.location.hash) {
      const sectionId = window.location.hash.substr(1);
      if (sectionId) {
        const element = document.getElementById(sectionId);
        if (element)
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, []);

  const getMetaData = () => {
    return (
      <Helmet>
        <title>{respData && respData.title}</title>
        <meta
          name="description"
          content={isEs ? BROWSE_PRESC_DESC_ES : BROWSE_PRESC_DESC_EN}
        />
        <link
          rel="canonical"
          href={`https://www.singlecare.com${location.pathname}`}
        />
        <link
          rel="alternate"
          href="https://www.singlecare.com/browse-prescriptions"
          hrefLang="en-us"
        />
        <link
          rel="alternate"
          href="https://www.singlecare.com/es/buscar-medicamentos"
          hrefLang="es-us"
        />
        <meta
          property="og:image"
          content={`${HOME_CANONICAL}/content/images/homepage/singleCareLogo.jpg`}
        />
        <meta
          property="og:url"
          content={`https://www.singlecare.com${location.pathname}`}
        />
        <meta property="og:site_name" content="SingleCare" />
        <meta property="og:type" content="website" />
        {API.ALLOW_HOTJAR && (
          <script type="text/javascript">{HOTJAR_SCRIPT}</script>
        )}
      </Helmet>
    );
  };

  return (
    <div className="homepage homepage-new mainBrowsePrescriptions">
      {getMetaData()}
      <div className="topShadow"></div>
      <section className={`home-masthead masthead--search show-recent`}>
        <div className="pageHeading">
          <SkipTo>
            <h1>
              <strong>{respData && respData.h1} </strong>
            </h1>
          </SkipTo>
          <div className="pill-icons">
            <span className="top-bg">
              <LazyLoadImage
                src="/content/images/icons/singlecare-pill-top.png"
                alt=""
              />
            </span>
            <span className="pillImg">
              <LazyLoadImage
                src="/content/images/icons/singlecare-pill.png"
                alt=""
              />
            </span>
          </div>
        </div>
        <div className="browsePrescriptionsSearch desktop-search desktop-only">
          <SearchBar
            classes="search-container"
            handleZipCodeChange={() => null}
            history={history}
            showZipCode={false}
          />
        </div>
        <div className="mobile-search">
          <button
            onClick={() => toggleSearch()}
            className="input-search open-search-mobile mobile-only whiteFocus"
          >
            {/*<span className="sc-icon sc-icon-search input-search--icon" />*/}
            <span className="input-search--placeholder">
              {t('Type your drug name')}
            </span>
          </button>
          <div className="site-search-form--query mobile-show">
            <button
              type="submit"
              value={t('Search')}
              className="search-btn sc-outline-btn--cool-gray"
            >
              <span className="search-icon">
                <LazyLoadImage
                  src="/content/images/icons/search-icon.svg"
                  alt=""
                  width="27"
                  height="27"
                />
              </span>
            </button>
          </div>
        </div>
      </section>

      <section id="az" className="alphabetSection">
        <div className="alphabetDrugs">
          <h2> {respData && respData.subtext}</h2>
          <ul className="alphabet">
            {alphabets.map(alphabet => (
              <li key={alphabet}>
                <a
                  href={_.withLocale(
                    i18n.language,
                    `/browse-prescriptions/${alphabet.toLowerCase()}`
                  )}
                  aria-label={t('Browse drugs by letter {{letter}} category', {
                    letter: alphabet
                  })}
                >
                  {alphabet}
                </a>
              </li>
            ))}
            <li>
              <a
                href={`${location.pathname}/0-9`}
                aria-label={t('Browse drugs by number category')}
              >
                0-9
              </a>
            </li>
          </ul>
        </div>
      </section>

      <section className="savingsSectionV2">
        <h2 className="textCenter savingHeader">{t('savingHead')}</h2>
        <SavingsSectionv2 />
      </section>

      <section id="td">
        <BrowseTopDrugs
          drugs={respData && respData.drugs}
          term={respData && respData.letter}
          heading={respData && respData.h2}
        />
      </section>
      <div className="browse-content">
        <h2>{respData && respData.subheadAtBottom}</h2>
        {documentToReactComponents(
          JSON.parse(respData && respData.textAtBottom)
        )}
      </div>

      <AppsPromoHome
        QRImage={'/content/images/homepagev2/hz9nm4kx_qr_code.svg'}
        appStoreLink={'https://singlecare.onelink.me/OxIQ/wda9nocc'}
        playStoreLink={'https://singlecare.onelink.me/OxIQ/8zyppn7x'}
        altText={t('QR code to download the app')}
      />
    </div>
  );
};
BrowsePrescriptionsMain.propTypes = {
  respData: object
};

BrowsePrescriptionsMain.defaultProps = {
  respData: {}
};
export default withTranslation()(BrowsePrescriptionsMain);
